// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/Menu.css */

/* Estilos para el ícono de categoría */
.category-icon {
    font-size: 1.2rem;   /* Tamaño pequeño para el ícono */
    vertical-align: middle;
    margin-right: 8px;   /* Espacio entre el ícono y el texto */
    color: var(--sn-marca);  /* Acento de marca del icono de categoria */
  }
  
  /* Contenedor del grupo de botones, distribuido uniformemente */
  .circle-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly; /* Espacio uniforme entre botones */
    align-items: flex-start;
    width: 100%;
  }
  
  /* Contenedor individual para cada botón circular */
  .circle-container {
    text-align: center;  /* Centramos todo el contenido (icono + texto) */
    margin: 10px;
    cursor: pointer;
    width: 120px; /* Ancho fijo para cada contenedor */
  }
  
  /* Estilos para el botón circular */
  .circle-btn {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: var(--sn-accion);  /* Color de fondo base */
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--sn-accion-texto);  /* Color del ícono */
    font-size: 2rem;            /* Tamaño del ícono */
    transition: background-color 0.3s ease, transform 0.3s ease;
    margin: 0 auto;             /* Para centrar el círculo dentro del contenedor */
  }
  
  .circle-btn:hover {
    background-color: var(--sn-accion-hover);  /* Color al pasar el mouse */
    transform: scale(1.05);     /* Efecto zoom suave */
  }
  
  /* Texto debajo del botón circular */
  .circle-text {
    margin-top: 8px;
    font-weight: 500;
    font-size: 1rem;            
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
    color: var(--sn-texto);
    display: block;             
    text-align: center;         /* Centra el texto */
  }
  
  /* Línea divisoria debajo del título de cada sección */
  .service-divider {
    width: 50%;
    margin: 0.5rem 0;
    border-top: 2px solid var(--sn-borde);
  }
  /* ===== ANIMACIÓN DEL BOT ===== */
@keyframes pulseBot {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--sn-marca-suave);
  }
  70% {
    transform: scale(1.08);
    box-shadow: 0 0 0 16px transparent;
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 transparent;
  }
}


/* Oculta el botón original de Typebot */
iframe[src*="typebot"] {
  pointer-events: none;
}

/* ===== Panel "Más" (bottom sheet) ===== */
.ln-more-sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  width: 100%;
  max-width: 100%;
}

.ln-more-sheet .modal-content {
  border-radius: 16px 16px 0 0;
  border: none;
}

/* ===== Menu "Más" (dropdown estilo hamburguesa) ===== */
.mn-more-toggle-btn::after {
  display: none;
}

.mn-more-menu {
  border-radius: 14px;
  border: 1px solid var(--sn-borde);
  box-shadow: var(--sn-sombra);
  padding: 6px;
  width: 240px;
  max-width: 80vw;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.mn-more-item {
  border-radius: 10px;
  padding: 8px 8px;
  font-size: 14px;
  width: 100%;
}

.mn-more-item:hover,
.mn-more-item:focus {
  background: var(--sn-superficie-2);
}

/* ===== Carrusel de ONTs (Detalles de la ONT) ===== */
.ont-carousel {
  scrollbar-width: none; /* Firefox */
}

.ont-carousel::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}`, "",{"version":3,"sources":["webpack://./src/pages/Menu.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB,uCAAuC;AACvC;IACI,iBAAiB,IAAI,iCAAiC;IACtD,sBAAsB;IACtB,iBAAiB,IAAI,sCAAsC;IAC3D,sBAAsB,GAAG,2CAA2C;EACtE;;EAEA,+DAA+D;EAC/D;IACE,aAAa;IACb,eAAe;IACf,6BAA6B,EAAE,mCAAmC;IAClE,uBAAuB;IACvB,WAAW;EACb;;EAEA,mDAAmD;EACnD;IACE,kBAAkB,GAAG,gDAAgD;IACrE,YAAY;IACZ,eAAe;IACf,YAAY,EAAE,oCAAoC;EACpD;;EAEA,mCAAmC;EACnC;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC,GAAG,wBAAwB;IAC7D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B,GAAG,oBAAoB;IACpD,eAAe,aAAa,qBAAqB;IACjD,2DAA2D;IAC3D,cAAc,cAAc,kDAAkD;EAChF;;EAEA;IACE,wCAAwC,GAAG,4BAA4B;IACvE,sBAAsB,MAAM,sBAAsB;EACpD;;EAEA,oCAAoC;EACpC;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,4DAA4D;IAC5D,sBAAsB;IACtB,cAAc;IACd,kBAAkB,UAAU,oBAAoB;EAClD;;EAEA,sDAAsD;EACtD;IACE,UAAU;IACV,gBAAgB;IAChB,qCAAqC;EACvC;EACA,kCAAkC;AACpC;EACE;IACE,mBAAmB;IACnB,yCAAyC;EAC3C;EACA;IACE,sBAAsB;IACtB,kCAAkC;EACpC;EACA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;AACF;;;AAGA,wCAAwC;AACxC;EACE,oBAAoB;AACtB;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,sDAAsD;AACtD;EACE,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,aAAa,EAAE,uBAAuB;AACxC","sourcesContent":["/* src/pages/Menu.css */\n\n/* Estilos para el ícono de categoría */\n.category-icon {\n    font-size: 1.2rem;   /* Tamaño pequeño para el ícono */\n    vertical-align: middle;\n    margin-right: 8px;   /* Espacio entre el ícono y el texto */\n    color: var(--sn-marca);  /* Acento de marca del icono de categoria */\n  }\n  \n  /* Contenedor del grupo de botones, distribuido uniformemente */\n  .circle-group {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-evenly; /* Espacio uniforme entre botones */\n    align-items: flex-start;\n    width: 100%;\n  }\n  \n  /* Contenedor individual para cada botón circular */\n  .circle-container {\n    text-align: center;  /* Centramos todo el contenido (icono + texto) */\n    margin: 10px;\n    cursor: pointer;\n    width: 120px; /* Ancho fijo para cada contenedor */\n  }\n  \n  /* Estilos para el botón circular */\n  .circle-btn {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background-color: var(--sn-accion);  /* Color de fondo base */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--sn-accion-texto);  /* Color del ícono */\n    font-size: 2rem;            /* Tamaño del ícono */\n    transition: background-color 0.3s ease, transform 0.3s ease;\n    margin: 0 auto;             /* Para centrar el círculo dentro del contenedor */\n  }\n  \n  .circle-btn:hover {\n    background-color: var(--sn-accion-hover);  /* Color al pasar el mouse */\n    transform: scale(1.05);     /* Efecto zoom suave */\n  }\n  \n  /* Texto debajo del botón circular */\n  .circle-text {\n    margin-top: 8px;\n    font-weight: 500;\n    font-size: 1rem;            \n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; \n    color: var(--sn-texto);\n    display: block;             \n    text-align: center;         /* Centra el texto */\n  }\n  \n  /* Línea divisoria debajo del título de cada sección */\n  .service-divider {\n    width: 50%;\n    margin: 0.5rem 0;\n    border-top: 2px solid var(--sn-borde);\n  }\n  /* ===== ANIMACIÓN DEL BOT ===== */\n@keyframes pulseBot {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 var(--sn-marca-suave);\n  }\n  70% {\n    transform: scale(1.08);\n    box-shadow: 0 0 0 16px transparent;\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n\n\n/* Oculta el botón original de Typebot */\niframe[src*=\"typebot\"] {\n  pointer-events: none;\n}\n\n/* ===== Panel \"Más\" (bottom sheet) ===== */\n.ln-more-sheet {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n.ln-more-sheet .modal-content {\n  border-radius: 16px 16px 0 0;\n  border: none;\n}\n\n/* ===== Menu \"Más\" (dropdown estilo hamburguesa) ===== */\n.mn-more-toggle-btn::after {\n  display: none;\n}\n\n.mn-more-menu {\n  border-radius: 14px;\n  border: 1px solid var(--sn-borde);\n  box-shadow: var(--sn-sombra);\n  padding: 6px;\n  width: 240px;\n  max-width: 80vw;\n  max-height: 60vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.mn-more-item {\n  border-radius: 10px;\n  padding: 8px 8px;\n  font-size: 14px;\n  width: 100%;\n}\n\n.mn-more-item:hover,\n.mn-more-item:focus {\n  background: var(--sn-superficie-2);\n}\n\n/* ===== Carrusel de ONTs (Detalles de la ONT) ===== */\n.ont-carousel {\n  scrollbar-width: none; /* Firefox */\n}\n\n.ont-carousel::-webkit-scrollbar {\n  display: none; /* Chrome/Safari/Edge */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
